// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__UUnsX","nav":"Header_nav__2CiLI","logo":"Header_logo__2lC9q","transitar":"Header_transitar__1d3Yz","login":"Header_login__i8bQC"};